import { NgModule } from '@angular/core';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { AgGridModule } from 'ag-grid-angular';
import { ProductsComponent } from 'src/app/features/products/products.component';
import { NewProductComponent } from './new-product/new-product.component';
import { ProductService } from './product.service';
import { NewProductSmartComponent } from './new-product/new-product-smart.component'; 
import { EditProductComponent } from './edit-product/edit-product.component';
import { EditProductSmartComponent } from './edit-product/edit-product-smart.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AllProductsComponent } from './all-products/all-products.component';
import { ProductsHistoryComponent } from './products-history/products-history.component';
import { ProductsImportComponent } from './products-import/products-import.component';
import { ProviderRoutingModule } from './product-routing.module';

@NgModule({
  declarations: [ProductsComponent, NewProductComponent, NewProductSmartComponent, EditProductComponent, EditProductSmartComponent, AllProductsComponent, ProductsHistoryComponent, ProductsImportComponent],
  imports: [
    AgGridModule.withComponents([]),
    FeaturesCommonModule,
    ProviderRoutingModule,
    ReactiveFormsModule
  ],
  exports: [ProductsComponent, NewProductComponent, NewProductSmartComponent, EditProductComponent, EditProductSmartComponent, AllProductsComponent, ProductsHistoryComponent, ProductsImportComponent
  ],
  providers: [ProductService]
})
export class ProductsModule { }
